var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedSuccessfully(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.9961 18.9961C36.0201 18.9961 18.9961 36.0201 18.9961 56.9961C18.9961 77.9721 36.0201 94.9961 56.9961 94.9961C77.9721 94.9961 94.9961 77.9721 94.9961 56.9961C94.9961 36.0201 77.9721 18.9961 56.9961 18.9961ZM46.6981 73.2981L33.0561 59.6561C31.5741 58.1741 31.5741 55.7801 33.0561 54.2981C34.5381 52.8161 36.9321 52.8161 38.4141 54.2981L49.3961 65.2421L75.5401 39.0981C77.0221 37.6161 79.4161 37.6161 80.8981 39.0981C82.3801 40.5801 82.3801 42.9741 80.8981 44.4561L52.0561 73.2981C50.6121 74.7801 48.1801 74.7801 46.6981 73.2981Z",
    fill: "#00371E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedSuccessfully);
export default __webpack_public_path__ + "static/media/checked-successfully.65567a50e6f7ae62f927f6c59cb75d1a.svg";
export { ForwardRef as ReactComponent };